export interface FooterLinkProps {
  href: string
  name: string
  underline?: boolean
}

export const FooterLink = ({ href, name, underline }: FooterLinkProps) => {
  return (
    <a
      href={href}
      className={`text-cool-gray-500 text-sm font-medium ${
        underline ? 'underline hover:no-underline' : 'hover:underline'
      }`}
    >
      {name}
    </a>
  )
}
